import { useState, useEffect } from "react";

function ProductionCard({ item }) {
  const [selectedImg, setSelectedImg] = useState(null);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const panel = document.querySelector(".panel");

    if (!panel) return;

    const handleScroll = () => {
      setScrollY(panel.scrollTop);
    };

    panel.addEventListener("scroll", handleScroll);

    return () => panel.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="prod-card">

      {/* TITLE / ROLE */}
      <h2 className="prod-title">{item.title}</h2>
      {item.role && <h3 className="prod-role">{item.role}</h3>}

      {/* IMAGES */}
      <div className="thumb">
        {item.images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={item.title}
            onClick={() => setSelectedImg(img)}
          />
        ))}
      </div>

      {/* DESCRIPTION */}
      <p className="prod-desc">{item.description}</p>

      {/* CREDITS */}
      <div className="prod-credits">
        <strong>Credits:</strong>
        <p>{item.credits}</p>

        {item.links && item.links.length > 0 && (
          <div className="prod-links">
            {item.links.map((link, index) => (
              <a
                key={index}
                href={link.url}
                target="_blank"
                rel="noreferrer"
                className="prod-link"
              >
                {link.text}
              </a>
            ))}
          </div>
        )}
      </div>

      {/* LIGHTBOX */}
      {selectedImg && (
        <div
          className={`lightbox ${selectedImg ? "active" : ""}`}
          onClick={() => setSelectedImg(null)}
          style={{ top: `${scrollY}px` }}
        >
          <img src={selectedImg} alt="full" />
        </div>
      )}

    </div>
  );
}

export default ProductionCard;